
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 12C22.5 6.20098 17.799 1.5 12 1.5C6.20098 1.5 1.5 6.20098 1.5 12C1.5 17.799 6.20098 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12ZM2.5 12C2.5 6.75327 6.75327 2.5 12 2.5C17.2467 2.5 21.5 6.75327 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75327 21.5 2.5 17.2467 2.5 12ZM15.8562 12.719C16.7386 12.4575 17.4575 11.902 17.915 11.183C18.2092 10.6928 18.3725 10.1699 18.3725 9.64706C18.3725 7.84967 16.7712 6.37909 14.7778 6.37909C14.0915 6.37909 13.4379 6.54248 12.8824 6.86928C11.8693 7.45752 11.183 8.47059 11.183 9.64706V14.5163C11.183 15.3987 10.3333 16.1176 9.28758 16.1176C8.24183 16.1176 7.39216 15.3987 7.39216 14.5163C7.39216 13.8627 7.81699 13.3399 8.43791 13.0784C8.47059 13.0458 8.53595 13.0131 8.56863 13.0131C8.96078 12.8497 9.28758 12.5556 9.4183 12.1961C9.5817 11.7059 9.2549 11.281 8.63399 11.281C8.49443 11.281 8.37872 11.3049 8.24612 11.3322C8.22346 11.3369 8.20031 11.3416 8.17647 11.3464C7.29412 11.6078 6.57516 12.1634 6.11765 12.8824C5.82353 13.3725 5.66013 13.8954 5.66013 14.4837C5.66013 16.281 7.26144 17.7516 9.2549 17.7516C9.94118 17.7516 10.5948 17.5882 11.1503 17.2614C12.1634 16.6732 12.8497 15.6601 12.8497 14.4837V9.61438C12.8497 8.73203 13.6993 8.01307 14.7451 8.01307C15.7908 8.01307 16.6405 8.73203 16.6405 9.61438C16.6405 10.268 16.183 10.8235 15.4967 11.085C15.0719 11.2157 14.7124 11.5425 14.5817 11.902C14.4183 12.3922 14.7451 12.817 15.366 12.817C15.5294 12.817 15.6601 12.7843 15.7908 12.7516L15.7908 12.7516C15.8096 12.7328 15.8176 12.7249 15.8272 12.7215C15.8343 12.719 15.8423 12.719 15.8562 12.719Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiMiniappFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
